export default __webpack_public_path__ + "static/media/RobotoSlab-Regular.a36eb364.ttf";